import { addError } from "@wayflyer/blackbox-fe";

/**
 * Report a failed insights request to error tracking, unless the browser dropped the connection: that request never
 * reached the server, so there is no application error to report.
 */
export function reportRequestFailure(context: string, failureMessage: string, isNetworkFailure: boolean) {
  if (isNetworkFailure) {
    return;
  }
  addError(new Error(`${context}: ${failureMessage}`));
}
